import { ComponentsOverrides, Theme } from '@mui/material';

export const MuiList: { styleOverrides: ComponentsOverrides<Theme>['MuiList'] } = {
    styleOverrides: {
        root: {
            minWidth: 233,
            '&.MuiMultiSectionDigitalClockSection-root': {
                minWidth: 70,
                boxSizing: 'border-box',
            },
        },
    },
};

export const MuiListItem: { styleOverrides: ComponentsOverrides<Theme>['MuiListItem'] } = {
    styleOverrides: {
        root: ({ theme }) => ({
            color: theme.palette.common.black,
            minHeight: 48,
            padding: '12px 16px',
        }),
    },
};

export const MuiListItemButton: { styleOverrides: ComponentsOverrides<Theme>['MuiListItemButton'] } = {
    styleOverrides: {
        root: {
            minHeight: 48,
            padding: '12px 16px',
        },
    },
};

export const MuiListItemText: { styleOverrides: ComponentsOverrides<Theme>['MuiListItemText'] } = {
    styleOverrides: {
        root: {
            whiteSpace: 'pre-wrap',
        },
    },
};

export const MuiListItemIcon: { styleOverrides: ComponentsOverrides<Theme>['MuiListItemIcon'] } = {
    styleOverrides: {
        root: ({ theme }) => ({
            color: theme.palette.common.black,
        }),
    },
};
